<template>
    <path d="M2.40009 3.12012H5.76009V21.3601H2.40009V3.12012Z" />
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6401 13.8001C16.8272 13.8001 18.6001 12.0272 18.6001 9.84013C18.6001 7.65308 16.8272 5.88013 14.6401 5.88013C12.4531 5.88013 10.6801 7.65308 10.6801 9.84013C10.6801 12.0272 12.4531 13.8001 14.6401 13.8001ZM14.6401 16.8001C18.484 16.8001 21.6001 13.684 21.6001 9.84013C21.6001 5.99623 18.484 2.88013 14.6401 2.88013C10.7962 2.88013 7.68011 5.99623 7.68011 9.84013C7.68011 13.684 10.7962 16.8001 14.6401 16.8001Z"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'IconPatreon',
})
</script>
